"use strict";

var _interopRequireDefault = require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js"));
var _slicedToArray2 = _interopRequireDefault(require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/esm/slicedToArray.js"));
var _objectWithoutProperties2 = _interopRequireDefault(require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js"));
var _react = _interopRequireDefault(require("react"));
var _classNames = _interopRequireDefault(require("../classNames"));
var _excluded = ["className", "length", "value"];
var _jsxFileName = "/Users/mweeb/Desktop/codings/nq-component/src/InputVerification/index.js";
function noop() {}
var defaultProps = {
  length: 6,
  value: '',
  onChange: noop,
  onComplete: noop
};
var KEY_CODE = {
  backspace: 8,
  left: 37,
  up: 38,
  right: 39,
  down: 40
};
function InputVerification(_ref) {
  var _this = this;
  var className = _ref.className,
    length = _ref.length,
    value = _ref.value,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _React$useState = _react["default"].useState(value ? value.split('') : Array(length).fill('')),
    _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
    values = _React$useState2[0],
    setValues = _React$useState2[1];
  var style = {
    maxWidth: 50
  };
  var refs = _react["default"].useMemo(function () {
    var refs = [];
    for (var i = 0; i < length; i++) {
      refs.push( /*#__PURE__*/_react["default"].createRef());
    }
    return refs;
  }, []);
  function onChange(index, e) {
    e.target.value = e.target.value.replace(/[^\d]/gi, '');
    if (e.target.value === '' || !e.target.validity.valid) {
      return;
    }
    var value = e.target.value;
    var next;
    if (value.length > 1) {
      var nextIndex = value.length + index - 1;
      if (nextIndex >= length) {
        nextIndex = length - 1;
      }
      next = refs[nextIndex];
      var split = value.split('');
      split.forEach(function (item, i) {
        var cursor = index + i;
        if (cursor < length) {
          values[cursor] = item;
        }
      });
      setValues((0, _toConsumableArray2["default"])(values));
    } else {
      next = refs[index + 1];
      values[index] = value;
      setValues((0, _toConsumableArray2["default"])(values));
    }
    if (next) {
      next.current.focus();
      next.current.select();
    }
    triggerChange(values);
  }
  function onKeyDown(index, e) {
    var prevIndex = index - 1;
    var nextIndex = index + 1;
    var prev = refs[prevIndex];
    var next = refs[nextIndex];
    switch (e.keyCode) {
      case KEY_CODE.backspace:
        e.preventDefault();
        if (values[index]) {
          values[index] = '';
          setValues((0, _toConsumableArray2["default"])(values));
          triggerChange(values);
        } else if (prev) {
          values[prevIndex] = '';
          prev.current.focus();
          setValues((0, _toConsumableArray2["default"])(values));
          triggerChange(values);
        }
        break;
      case KEY_CODE.left:
        e.preventDefault();
        if (prev) {
          prev.current.focus();
        }
        break;
      case KEY_CODE.right:
        e.preventDefault();
        if (next) {
          next.current.focus();
        }
        break;
      case KEY_CODE.up:
      case KEY_CODE.down:
        e.preventDefault();
        break;
      default:
    }
  }
  function onFocus(e) {
    e.target.select(e);
  }
  function triggerChange(values) {
    var value = values.join('');
    props.onChange(value);
    if (value.length >= length) {
      props.onComplete(value);
    }
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classNames["default"])(className, "d-flex justify-content-center"),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 120,
      columnNumber: 9
    }
  }, values.map(function (value, index) {
    return /*#__PURE__*/_react["default"].createElement("input", {
      key: index,
      value: value,
      ref: refs[index],
      className: "form-control form-control-lg text-center me-1 p-0",
      type: "tel",
      pattern: "[0-9]*",
      onChange: onChange.bind(_this, index),
      onKeyDown: onKeyDown.bind(_this, index),
      onFocus: onFocus,
      style: style,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 124,
        columnNumber: 25
      }
    });
  }));
}
InputVerification.defaultProps = defaultProps;
var _default = exports["default"] = InputVerification;